import { render, staticRenderFns } from "./app_style_temp_edit.vue?vue&type=template&id=f4bb8f82&"
import script from "./app_style_temp_edit.vue?vue&type=script&lang=js&"
export * from "./app_style_temp_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports